import React, { Component } from "react";

import "./ServiceCard.scss";

import { IconCheck } from "../../Icons/Icons";
import Switch from "../../Inputs/Switch/Switch";
import { moneyFormat } from "../../../utils/Masks/Masks";

export default class ServiceCard extends Component {
    constructor(props) {
        super(props);

        this.state = {
            checked: this.props.checked || false,
        };
    }

    render() {
        const { className } = this.props;

        return (
            <div
                onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    this.props.onDetail(this.props.serviceId);
                }}
                className={`service-card ${className || ""} ${
                    this.state.checked && "checked"
                }`}
                style={{
                    border: this.state.checked
                        ? "solid 2px #00A326"
                        : "solid 2px #01C4FE",
                    boxShadow: "none",
                    width: "280px",
                    height: "320px",
                }}
            >
                {this.props.title && (
                    <p
                        style={{
                            fontWeight: 600,
                            fontSize: 24,
                            lineHeight: "26px",
                            color: "#053462",
                            fontStyle: "italic",
                            paddingTop: "50px",
                            height: "60px",
                        }}
                    >
                        {this.props.title}
                    </p>
                )}
                <div
                    style={{
                        display: "flex",
                        justifyContent: "center",
                        alignItems: "center",
                        height: "80px",
                    }}
                >
                    <span
                        className={`price-badge ${
                            !this.props.price && "hidden"
                        }`}
                        style={{
                            marginTop: "8px",
                            height: "36px",
                            display: "flex",
                            justifyContent: "center",
                            alignItems: "center",
                            fontSize: "14px",
                            fontWeight: 500,
                            color: "#053462",
                            width: "auto",
                            padding: "0 12px",
                        }}
                    >
                        {this.props.price
                            ? moneyFormat(this.props.price)
                            : "--"}
                    </span>
                </div>
                {this.props.description && (
                    <p className="description">{this.props.description}</p>
                )}
                <footer>
                    <Switch
                        data-testid="contract-switch"
                        checked={this.state.checked}
                        onChange={this.props.onContract || (() => null)}
                        onHandleColor="#00A326"
                        onColor="#7FD192"
                    />

                    <button
                        className="link"
                        onClick={this.props.onContract}
                        style={{
                            fontWeight: 700,
                            fontSize: 12,
                            color: "#01C4FE",
                            textDecoration: "none",
                            textTransform: "none",
                            marginLeft: "6px",
                        }}
                    >
                        Selecionar
                    </button>

                    <button
                        className="link"
                        style={{
                            fontWeight: 700,
                            fontSize: 12,
                            color: "#01C4FE",
                            textDecoration: "none",
                            textTransform: "none",
                            float: "right",
                        }}
                        onClick={() =>
                            this.props.onDetail(this.props.serviceId)
                        }
                    >
                        Ver Mais
                    </button>
                </footer>
            </div>
        );
    }
}
